import Vue from "vue";
import App from "./App";
// import '@babel/polyfill'
import './plugins/vuetify'
import './registerServiceWorker'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import router from "./router";
import axios from "axios";
import store from "./vuex/store.js";
import { Sync } from "./class/sync";
import { Me } from "./class/me";

import "material-design-icons/iconfont/material-icons.css";
import "typeface-roboto/index.css";

Vue.config.productionTip = false;

if (!("indexedDB" in window)) {
    console.log("This browser doesn't support IndexedDB");
}

/**
 * @return Promisse
 */
// eslint-disable-next-line no-undef
export const dbPromise = idb.open("ca2", 1, function (upgradeDb) {
    if (!upgradeDb.objectStoreNames.contains("ordens")) {
        upgradeDb.createObjectStore("ordens", { keyPath: "id_ordem_servico" });
    }
    if (!upgradeDb.objectStoreNames.contains("user")) {
        upgradeDb.createObjectStore("user", { keyPath: "id" });
    }
    if (!upgradeDb.objectStoreNames.contains("phone")) {
        upgradeDb.createObjectStore("phone", { keyPath: "id" });
    }
    if (!upgradeDb.objectStoreNames.contains("sync")) {
        upgradeDb.createObjectStore("sync", { autoIncrement: true });
    }
});

export const getConnection = () => {
    return navigator.connection || navigator.mozConnection ||
        navigator.webkitConnection || navigator.msConnection;
};

/*
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDU5eewYrm5YIYEk2vK_56jQVv5jm0rhBU"
    }
});
*/

axios.defaults.baseURL = "https://tecnicos2.centersattelecom.com.br";
// axios.defaults.baseURL = "http://192.168.3.50:8905";
// axios.defaults.baseURL = "http://localhost:8905";

Me.get().then((data) => {
    if (data) { axios.defaults.headers.common["Authorization"] = "JWT " + data.token; }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    render: h => h(App),
    router,
    components: { App },
    store,
    beforeMount () {
        window.document.addEventListener("visibilitychange", this.updateStatus, false);
        window.addEventListener("online", this.updateStatus);
        window.addEventListener("offline", this.updateStatus);
        this.updateStatus();
    },
    methods: {
        updateStatus: function (e) {
            Sync.syncAll(this.$socket)
                .catch((err) => console.error(err));
        }
    },
    template: "<App/>"
}).$mount('#app');
